<template>
  <div class="favorites-wrapper" v-click-outside="close" v-resize="resize">
    <favorites-badge :active="active" @click.native="active = !active" />
    <div v-if="active && isMobile" class="mobile-favorites">
      <user-favorites
        class="user-favorites"
        :language="focusKnowledgeLanguage"
        @select-item="selectItem"
      />
    </div>
    <div v-else-if="active" class="favorites-dropdown">
      <user-favorites
        :language="focusKnowledgeLanguage"
        @select-item="selectItem"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'mayday-web-user-favorites',
  components: {},
  data() {
    return {
      active: false,
      width: document.documentElement.clientWidth,
    };
  },
  computed: {
    isMobile() {
      return this.width <= 991;
    },
    ...mapGetters('webKnowledgeModule', ['focusKnowledgeLanguage']),
  },
  watch: {
    active(val) {
      const documentClasses = document.body.classList;
      val
        ? documentClasses.add('modal-open')
        : documentClasses.remove('modal-open');
    },
  },
  methods: {
    resize({ width }) {
      this.width = width;
    },
    close() {
      this.active = false;
    },
    selectItem(content) {
      this.goToContent({ contentId: content.id });
      this.close();
    },
    ...mapActions('webKnowledgeModule', ['goToContent']),
  },
};
</script>

<style lang="scss" scoped>
.favorites-wrapper {
  position: relative;
}

.favorites-dropdown {
  position: absolute;
  width: 350px;
  background-color: white;
  border: 1px solid $grey-3-mayday;
  border-radius: 4px;
  margin-top: 12px;
  right: -6px;
  z-index: 2000;
}

.mobile-favorites {
  position: fixed;
  top: 56px;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: white;

  .user-favorites {
    width: 100%;

    :deep() .md-favorites-list {
      height: calc(100vh - 145px) !important;
      max-height: calc(100vh - 145px) !important;
    }
  }
}
</style>
